import 'jquery-nice-select/js/jquery.nice-select.min';

$(document).ready(function() {
    $('select').niceSelect();
});
